<!-- #region Form Content -->
<form [formGroup]="logForm" id="logForm">
  <!-- #region Action Buttons -->
  <div class="row">
    <div class="col-12 divCenter" style="display: table">
      <!-- #region Cancel -->
      <p-button (onClick)="cancel()" class="red-btn mt-4 action-btn"><em class="pi pi-times-circle mr-2"></em> Cancel</p-button>
      <!-- #endregion Cancel-->

      <!-- #region Submit -->
      @if (userPermissions && (userPermissions.permissions.includes('system admin') || userPermissions.permissions.includes('update weld log'))) {
        <p-button
          class="mt-4 mr-2 action-btn"
          (onClick)="submitNewLog()"
          >Update Weld Logs</p-button
          >
        }
        <!-- #endregion Submit -->
      </div>
    </div>
    <!-- #endregion Action Buttons -->

    <!-- #region Field Row -->
    <div formArrayName="fieldsArray">
      @for (field of getFieldRows().controls; track field; let i = $index) {
        <div>
          <div [formGroupName]="i" class="row">
            <!-- Field Type column - Move outside the switch -->
            <div class="col-4">
              <label for="fieldType">Field</label>
              <p-select
                name="fieldType"
                formControlName="fieldType"
                optionValue="id"
                optionLabel="name"
                placeholder="Select a field"
                appendTo="body"
                [required]="true"
                [options]="fieldDropDownList.items"
                [filter]="true"
                (onChange)="onFieldSelect($event, i)"
              ></p-select>
            </div>
            <!-- Switch content in a separate element -->
            <div class="col-6">
              @switch (getFieldRows().at(i).value['fieldType']) {
                @case ('ewonumber') {
                  <div>
                    <label for="ewonumber">EWO <span style="color: red">*</span></label>
                    <input
                      #ewonum
                      pInputText
                      type="text"
                      class="formInput"
                      name="ewonumber"
                      formControlName="ewonumber"
                      placeholder="Enter EWO"
                      maxlength="25"
                      oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)"
                      (keypress)="keyValidation.alphanumericHyphen($event)"
                      />
                    </div>
                  }
                  @case ('projectOrPo') {
                    <div>
                      <label for="projectOrPo">Project/PO #</label>
                      <input pInputText type="text" class="formInput" name="projectOrPo" formControlName="projectOrPo" placeholder="Enter Project/PO #" maxlength="25" />
                    </div>
                  }
                  @case ('weldGroupId') {
                    <div>
                      <label for="weldGroupId">Group <span style="color: red">*</span></label>
                      <p-select
                        optionValue="id"
                        optionLabel="name"
                        name="weldGroupId"
                        formControlName="weldGroupId"
                        placeholder="Select a Group"
                        appendTo="body"
                        [options]="_srvDropDown.WeldGroups.items"
                        [filter]="true"
                      ></p-select>
                    </div>
                  }
                  @case ('wpsid') {
                    <div>
                      <label for="wpsid">WPS</label>
                      <p-select
                        name="wpsid"
                        formControlName="wpsid"
                        optionValue="id"
                        optionLabel="name"
                        placeholder="Select a WPS"
                        appendTo="body"
                        [options]="_srvDropDown.wps.items"
                        [filter]="true"
                      ></p-select>
                    </div>
                  }
                  @case ('spec') {
                    <div>
                      <label for="spec">Pipe Spec <span style="color: red">*</span></label>
                      <input
                        pInputText
                        class="formInput"
                        type="text"
                        name="spec"
                        formControlName="spec"
                        [ngModel]="this.logForm.value.spec"
                        (ngModelChange)="this.logForm.value.spec ? (this.logForm.value.spec = $event.toUpperCase()) : null"
                        placeholder="Enter Spec"
                        maxlength="25"
                        (keypress)="keyValidation.alphanumeric($event)"
                        />
                      </div>
                    }
                    @case ('rtpercentageId') {
                      <div>
                        <label for="rtpercentageId">RT Percentage <span style="color: red">*</span></label>
                        <p-select
                          name="rtpercentageId"
                          formControlName="rtpercentageId"
                          optionValue="id"
                          optionLabel="name"
                          placeholder="Select a RT Percent"
                          appendTo="body"
                          [options]="_srvDropDown.rtPercent.items"
                          [filter]="true"
                        ></p-select>
                      </div>
                    }
                    @case ('drawing') {
                      <div>
                        <label for="drawing">Drawing <span style="color: red" [hidden]="hideForMCBU">*</span></label>
                        <input pInputText class="formInput" type="text" name="drawing" formControlName="drawing" placeholder="Enter Drawing" maxlength="50" />
                      </div>
                    }
                    @case ('jointTypeId') {
                      <div>
                        <label for="jointTypeId">Joint Type <span style="color: red">*</span></label>
                        <p-select
                          #jointType
                          optionValue="id"
                          optionLabel="name"
                          name="jointTypeId"
                          formControlName="jointTypeId"
                          placeholder="Select a Joint Type"
                          appendTo="body"
                          [options]="_srvDropDown.jointTypes.items"
                          [filter]="true"
                        ></p-select>
                      </div>
                    }
                    @case ('dateWelded') {
                      <div class="calendarDiv">
                        <label for="dateWelded">Weld Date <span style="color: red">*</span></label>
                        <p-datepicker
                          class="formCalendar"
                          name="dateWelded"
                          formControlName="dateWelded"
                          dataType="string"
                          dateFormat="yy-mm-dd"
                          placeholder="Enter Date"
                          appendTo="body"
                          [readonlyInput]="true"
                          [showButtonBar]="true"
                        ></p-datepicker>
                      </div>
                    }
                  }
                </div>
                <!-- #region Add, Delete Buttons -->
                <div class="col-2 bottom">
                  <!-- #region Add -->
                  @if (this.getFieldRows().getRawValue().length < 9) {
                    <p-button
                      class="green-btn"
                      icon="pi pi-plus"
                      pTooltip="Add new row"
                      tooltipPosition="right"
                      [disabled]="false"
                      (onClick)="addAllocationRow()"
                    ></p-button>
                  }
                  <!-- #endregion -->
                  <!-- #region Delete -->
                  @if (this.getFieldRows().getRawValue().length > 1) {
                    <p-button
                      class="red-btn ml-2"
                      icon="pi pi-trash"
                      pTooltip="Delete row"
                      tooltipPosition="right"
                      [disabled]="false"
                      (onClick)="removeAllocationRow(i)"
                    ></p-button>
                  }
                  <!-- #endregion -->
                </div>
                <!-- #endregion Add, Delete Buttons -->
              </div>
            </div>
          }
        </div>
        <!-- #endregion Field Row -->
      </form>
      <!-- #endregion Form Content -->

